import { jwtDecode } from 'jwt-decode';

export function decodeJWT(token) {
    if (!token || typeof token !== 'string') return false
  
    try {
        const decoded = jwtDecode(token);
        if (decoded.exp && Date.now() >= decoded.exp * 1000) {
            return false;
        }
        return decoded;
    } catch (error) {
        return false;
    }
}